module.exports = __webpack_public_path__ + "media/images/dashboard/banner_img-d9c72f2c52e7d01677818f2611d1374b.png";